import { ReactNode } from "react";
import "./PhotoComments.scss";
import NewComment from "../NewComment/NewComment";

interface PhotoCommentsPropsI {
	children: ReactNode;
}

function PhotoComments(props: PhotoCommentsPropsI) {
	return (
		<div className="photo-comments-component-main-container">
			{props.children}
		</div>
	);
}

export default PhotoComments;
